var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-row"},[_c('subMap',{ref:"subMap",attrs:{"path":_vm.path,"layers":_vm.layers},on:{"setLocation":_vm.setLocation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }